import { render } from "./IconTag.vue?vue&type=template&id=f6c3d18a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6c3d18a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6c3d18a', __exports__)) {
    api.reload('f6c3d18a', __exports__)
  }
  
  module.hot.accept("./IconTag.vue?vue&type=template&id=f6c3d18a", () => {
    api.rerender('f6c3d18a', render)
  })

}


export default __exports__